import { Alert, Snackbar, SnackbarCloseReason } from "@mui/material";
import { useTypedDispatch, useTypedSelector } from "hooks/store";
import React from "react";
import { openNotification } from "state/slices/NotificationSlice";

const NotificationComponent = (): JSX.Element => {
    const dispatch = useTypedDispatch();
    const notification = useTypedSelector((store) => store.Notification);

    const handleClose = (event?: React.SyntheticEvent | Event, reason?: SnackbarCloseReason) => {
        if (reason === "clickaway") {
            return;
        }

        dispatch(
            openNotification({
                isNotificationOpen: false,
                text: notification.text,
                type: notification.type,
            })
        );
    };

    return (
        <Snackbar
            key={notification.id}
            open={notification.isNotificationOpen}
            autoHideDuration={6000}
            onClose={handleClose}
        >
            <Alert
                onClose={handleClose}
                severity={notification.type}
                variant="filled"
                sx={{
                    "& .MuiAlert-message": {
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        width: 200,
                        display: "block",
                    },
                }}
            >
                {notification.text}
            </Alert>
        </Snackbar>
    );
};

export default NotificationComponent;
